import { render, staticRenderFns } from "./EpanetShowConsumos.vue?vue&type=template&id=64acbda5&"
import script from "./EpanetShowConsumos.vue?vue&type=script&lang=js&"
export * from "./EpanetShowConsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports